import { api } from './../../api.js';

import axios from 'axios';

const state = {
	
}

const getters = {
	
}

const mutations = {
	
}

const actions = {

	getLessons : function({ commit }, data){

		return new Promise((resolve, reject) => {
			var params = {
				filters : {
					...data.filters,
					exclude: ['lessons_has_tincan', 'lessons_tincan_operations', 'lessons_miscellanous_info', 'lessons_tags'],
				}
			}

			api.get('admin/lessons', params).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},
	getLessonsWithQuiz : function({ commit }, data){

		return new Promise((resolve, reject) => {
			var params = {
				filters : data.filters
			}

			api.get('admin/lessons/quizzes', params).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},

	getLesson : function({ commit }, data){
		return new Promise((resolve, reject) => {
			api.get('admin/lessons/'+data.id, {}).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			})
		});
	},

	createLesson : function({ commit }, data){

		return new Promise((resolve, reject) => {
			api.post('admin/lessons', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			})
		});
	},

	editLesson : function({ commit }, data){
		return new Promise((resolve, reject) => {
			api.patch('admin/lessons/'+data.id, data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	downloadTincan : function({ commit }, data){
		return new Promise((resolve, reject) => {
			api.get('admin/lessons/'+data.id+'/download-tincan', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error);
			});
		})
	},
	removeTincan : function({ commit }, data){
		return new Promise((resolve, reject) => {
			api.delete('admin/lessons/'+data.id+'/delete-tincan/'+data.key, data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	downloadAttachment : function({ commit }, data){

	},
	removeAttachment : function({ commit }, data){
		return new Promise((resolve, reject) => {
			api.delete('admin/lessons/'+data.id+'/delete-attachment/'+data.attachment_id, data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	getFileTypes : function({ commit }, data){
		return new Promise((resolve, reject) => {
			api.get('admin/lessons/filetypes', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error);
			});
		});
	}
}

export default {
	state, 
	actions,
	getters,
	mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/LessonModule.js